var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrosswordIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#34C96D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 5.4C8.5 4.90294 8.90294 4.5 9.4 4.5H12.6C13.0971 4.5 13.5 4.90294 13.5 5.4V9.5H8.5V5.4ZM9.5 5.5V8.5H12.5V5.5H9.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8.5H13.5V13.5H8.5V8.5ZM9.5 9.5V12.5H12.5V9.5H9.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 12.5H13.5V17.5H8.5V12.5ZM9.5 13.5V16.5H12.5V13.5H9.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 16.5H13.5V20.6C13.5 21.0971 13.0971 21.5 12.6 21.5H9.4C8.90294 21.5 8.5 21.0971 8.5 20.6V16.5ZM9.5 17.5V20.5H12.5V17.5H9.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 13.4C4.5 12.9029 4.90294 12.5 5.4 12.5H9.5V17.5H5.4C4.90294 17.5 4.5 17.0971 4.5 16.6V13.4ZM5.5 13.5V16.5H8.5V13.5H5.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 16.5H21.5V21.5H16.5V16.5ZM17.5 17.5V20.5H20.5V17.5H17.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 20.5H21.5V24.6C21.5 25.0971 21.0971 25.5 20.6 25.5H17.4C16.9029 25.5 16.5 25.0971 16.5 24.6V20.5ZM17.5 21.5V24.5H20.5V21.5H17.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 12.5H17.5V17.5H12.5V12.5ZM13.5 13.5V16.5H16.5V13.5H13.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 9.4C16.5 8.90294 16.9029 8.5 17.4 8.5H20.6C21.0971 8.5 21.5 8.90294 21.5 9.4V13.5H16.5V9.4ZM17.5 9.5V12.5H20.5V9.5H17.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 12.5H21.5V17.5H16.5V12.5ZM17.5 13.5V16.5H20.5V13.5H17.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 12.5H24.6C25.0971 12.5 25.5 12.9029 25.5 13.4V16.6C25.5 17.0971 25.0971 17.5 24.6 17.5H20.5V12.5ZM21.5 13.5V16.5H24.5V13.5H21.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosswordIconActive);
export default __webpack_public_path__ + "static/media/crossword_icon--active.b783a4516e8d86f0c93f2a6392d8d8ea.svg";
export { ForwardRef as ReactComponent };